exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".xc0ZfFIXWoWfzRA9LXcmP .ms-Panel-content{overflow-y:hidden;height:100%}html[dir] .xc0ZfFIXWoWfzRA9LXcmP .ms-Panel-content{padding:0!important}.C2_qJfqGlXKdBhkj6oaU2{height:100%}", ""]);

// exports
exports.locals = {
	"timeFlex": "xc0ZfFIXWoWfzRA9LXcmP",
	"timesPane": "C2_qJfqGlXKdBhkj6oaU2"
};